import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import one from './bachround_img/bg6.png'
import two from './bachround_img/bg7.png'
import base from './base_url'


function MobileBannerSlider(props) {
  return (
    <Carousel>
{


props.bannerList.map((e)=>(
     <Carousel.Item>
      <img
      className="d-block w-100"
      src={base.base+"/"+e.banner_img}
      alt="Second slide"
      style={{width:'100%'}}
    />
      </Carousel.Item>

))
   

}

  
    </Carousel>
  );
}

export default MobileBannerSlider;
